import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AudioCaptions, Caption } from 'unc-react-audio-captions';
import 'animate.css/animate.min.css';
import './slide.css';

export const SlideshowContext = createContext();
const EndTimes = [];
let setDisplayLearn = '';
let stepCompleted = '';
let module = '';

export function Slideshow({ children }) {
  const [context, setContext] = useState({
    items: [],
    edge: false,
    counter: 0,
    endTime: [],
    firstLoop: false,
    currentTime: 0,
    nextTime: 0,
  });
  const timer = useRef(null);

  useEffect(() => {
    timer.current = setTimeout(() => {
      // Move deactivated slide out when edge is false
      // Move activated slide in when edge is true
      const head = context.items.shift();
      const timeHead = EndTimes.shift();
      context.items.push(head);
      EndTimes.push(timeHead);

      setContext({ ...context });
    }, EndTimes[1] * 1000 - EndTimes[0] * 1000);
  });

  return (
    <SlideshowContext.Provider value={[context, setContext]}>
      <div
        style={{
          height: '80%',
          overflow: 'hidden',
        }}
      >
        {children}
      </div>
    </SlideshowContext.Provider>
  );
}

export function SlideshowItem({ children }) {
  const nameRef = useRef(`${performance.now()}_${Math.random()}`);
  const { items } = useContext(SlideshowContext);
  const [stage, setStage] = useState('ready');
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const currentName = nameRef.current;
    items.push(currentName);
    return () => {
      const index = items.indexOf(currentName);
      items.splice(index, 1);
    };
  }, [items]);

  useEffect(() => {
    const activeName = items[0];
    // Use a different name for the counter variable
    if (activeName === nameRef.current) {
      setStage('on');
    } else if (activeName !== nameRef.current && stage === 'on') {
      setStage('off');
      setCounter(counter + 1);
    } else if (activeName !== nameRef.current && stage === 'off') {
      setStage('ready');
    }
  }, [counter, items, stage]);

  let top = 0;
  let zIndex = 0;
  switch (stage) {
    case 'ready':
      top = '80%';
      break;
    case 'on':
      top = '0';
      zIndex = 1;
      break;
    case 'off':
      zIndex = 0;
      break;
    default:
  }

  return (
    <div
      style={{
        transition: '0.5s',
        position: 'absolute',
        top,
        left: 0,
        zIndex,
      }}
    >
      {children}
    </div>
  );
}

export default function SlideShow(props) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const cc = login.cloudFront + 'images/Module1Images/SubtitleIcon_On.png' + login.cookie;
  for (let i = 0; i < props.slides.length + 1; i++) {
    if (i === 0) {
      EndTimes[0] = 0.0;
    } else {
      EndTimes[i] = props.slides[i - 1].endTime;
    }
  }
  setDisplayLearn = props.setDisplayLearn;
  stepCompleted = props.step_completed;
  module = props.module;
  const dispatch = useDispatch();

  const ccopen = () => {
    const cc = document.getElementById('caption').style.display;
    if (cc === 'block') {
      document.getElementById('caption').style.display = 'none';
      if (module.reviewIcon === false) {
        dispatch({ type: stepCompleted, payload: 'learn' });
      }
      setDisplayLearn(false);
    } else {
      document.getElementById('caption').style.display = 'block';
    }
  };

  const lyrics = [];
  const slides = [];

  for (let i = 0; i < props.slides.length; i++) {
    slides.push(
      <SlideshowItem key={i}>
        <img src={props.slides[i].img} alt='Slide' className='slide-image' />
      </SlideshowItem>
    );
  }

  for (let j = 0; j < props.lyrics.length; j++) {
    let nextCaption = 500;
    if (j < props.lyrics.length - 1) {
      nextCaption = props.lyrics[j + 1].time;
    }
    lyrics.push(
      <Caption key={j} start={props.lyrics[j].time} end={nextCaption} noDisplay>
        <h1 className='captionText'>{props.lyrics[j].lyric}</h1>
      </Caption>
    );
  }

  return (
    <div className='Slides'>
      <audio autoPlay>
        <source src={props.instrumental}></source>
      </audio>
      <audio
        autoPlay
        muted
        onEnded={() => {
          if (module.reviewIcon === false) {
            dispatch({ type: stepCompleted, payload: 'learn' });
          }
          setDisplayLearn(false);
        }}
      >
        <source src={props.audio}></source>
      </audio>
      <img
        className='cc'
        src={cc}
        alt='cc'
        onClick={() => {
          ccopen();
        }}
      />
      <div className='slide'>
        <Slideshow width={200} height={200} id='slideshow-holder'>
          {slides}
        </Slideshow>
      </div>
      <AudioCaptions src={props.audio} controls autoPlay>
        <div id='caption' style={{ display: 'block' }}>
          {lyrics}
        </div>
      </AudioCaptions>
    </div>
  );
}
